import React from "react";
import { Container } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import ContactForm from "@Index/components/Contact/components/ContactForm";
import contactFormSchema from "@Index/components/Contact/lib/contactFormSchema";
import { IContactFormData } from "@Index/components/Contact/types/contact";

const Contact = (): React.JSX.Element => {
    const methods = useForm<IContactFormData>({
        mode: "onChange",
        resolver: yupResolver(contactFormSchema),
    });

    return (
        <div data-testid="contactContent">
            <Container className="py-5 contact">
                <FormProvider {...methods}>
                    <ContactForm />
                </FormProvider>
            </Container>
        </div>
    );
};

export default Contact;
